import { Component, inject } from '@angular/core';
import { KeyValuePipe } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { LeafletGroupComponent } from '@components/leaflet/group/group.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import {
  CountryList,
  MapType,
  WorldLanguage,
} from '@models';

@Component({
  selector: 'app-map-filters',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  imports: [
    KeyValuePipe,
    LeafletGroupComponent,
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
  ],
})
export class MapArchiveFilterComponent {
  dialogRef = inject<MatDialogRef<MapArchiveFilterComponent>>(MatDialogRef);

  mapTypes = MapType;
  countries = CountryList;
  languages = WorldLanguage;

  location: GeoJSON.FeatureCollection | undefined;

  filterForm: FormGroup;

  mapType: FormControl;
  geojson: FormControl;

  constructor() {
    const data = inject<{
      geojson: GeoJSON.FeatureCollection | undefined,
      mapType: MapType | undefined,
    }>(MAT_DIALOG_DATA)

    this.location = data?.geojson;
    this.mapType = new FormControl(data?.mapType || undefined);
    this.geojson = new FormControl(data?.geojson || undefined);

    this.filterForm = new FormGroup({
      mapType: this.mapType,
      geojson: this.geojson,
    });
  }

  onGeoSearch(geometry: GeoJSON.FeatureCollection | undefined) {
    this.geojson.setValue(geometry);
    this.location = geometry;
    this.filterForm.markAsDirty();
  }

  submit() {
    if (this.filterForm.pristine || !this.filterForm.valid) {
      return;
    }

    this.dialogRef.close({
      mapType: this.filterForm.value.mapType?.toLowerCase(),
      geojson: this.filterForm.value.geojson,
    });
  }
}
